/**
 * @file EmailCoverageWidget.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-02-02
 * @modified 2026-02-02
 */

import React from 'react';

function EmailCoverageWidget({ stats, loading }) {
  if (loading) {
    return null;
  }

  const emailPercentage = stats ? (stats.withEmail / stats.totalAccounts * 100).toFixed(1) : 0;

  return (
    <div className="dashboard-card email-coverage-card">
      <div className="card-header">
        <h3>
          <span className="material-symbols-rounded">mail</span>
          Email
        </h3>
      </div>
      <div className="card-body email-coverage-body">
        <div className="circular-progress">
          <svg viewBox="0 0 36 36" className="circular-chart">
            <path
              className="circle-bg"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle"
              strokeDasharray={`${emailPercentage}, 100`}
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="20.35" className="percentage">{emailPercentage}%</text>
          </svg>
          <p className="coverage-label">Contacts with Email</p>
        </div>
      </div>
    </div>
  );
}

export default EmailCoverageWidget;
